import { render } from "./Exam.vue?vue&type=template&id=15106643&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=ts"
export * from "./Exam.vue?vue&type=script&lang=ts"

import "./Exam.vue?vue&type=style&index=0&id=15106643&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15106643"

export default script